module.exports = __webpack_public_path__ + "img/OfficeDraw-icon.dea4be6e.png";